import Ws from "../../providers/Ws";

    

export default class FromServer {

    getMesagerie =async() =>{

        let ws = new Ws();

        let getMessagerie = await ws.getData('ActionsNotifications/SumarZi',{an:new Date().getFullYear(), 
            luna:new Date().getMonth() + 1, 
            zi:new Date().getDate()})

            // console.log('getMessagerie :', getMessagerie);

            let logFull = []

            if(getMessagerie.Succes){
                let logErr = [...getMessagerie.Content.logErr]

                let logSucces = [...getMessagerie.Content.logSucces]

                let counter1 = logErr.length
                let counter2 = logSucces.length

              

                for(let i = 0; i< counter1; i ++){

                    logFull.push({msg:logErr[i], status:'err'})
                };

                for(let i =0; i<counter2; i++){
                    logFull.push({msg:logSucces[i], status:'success'})
                };

                return {r:true, c:logFull, m:getMessagerie.Messsage}
            }else{
                return {r:false, m:getMessagerie.Messsage, c:[]}
            }

           
    }

}